import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ element, roles, redirectTo = '/login' }) {
  const token = localStorage.getItem('token');
  const user = (() => {
    try { return JSON.parse(localStorage.getItem('user') || '{}'); }
    catch { return {}; }
  })();

  if (!token) return <Navigate to="/login" replace />;

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return element;
}

export default ProtectedRoute;
